import React from 'react';
import {FormHelperText} from '@material-ui/core';
import {AutoField} from 'components/forms/fields';
import Section from 'components/forms/Section';
import useFieldData from 'components/forms/hooks/useFieldData';
import {Typography} from '@material-ui/core';
import fields from '../cg719s/fields';
import {bootstrapOldForm} from 'components/forms/AutoSection';
import Joi from 'joi';

const Owner = props => {
    const [owner, setOwner] = useFieldData('owner_operator_or_master');
    const {initialValues} = bootstrapOldForm('Ownership', fields);
    const showOwnerText = owner === true || owner === 'true';

    const schema = {
        owner_operator_or_master: Joi.boolean()
            .required()
            .invalid(false)
            .messages({
                'any.invalid':
                    'At the moment we are only creating CG719S forms for owners of their own vessels. Check back soon as we are adding this functionality in the near future!',
            }),
    };
    return (
        <Section {...props} {...{schema, initialValues}}>
            <Typography variant='h6' align='left'>
                Vessel Owner
            </Typography>
            <AutoField
                field={fields.owner_operator_or_master}
                name='owner_operator_or_master'
                onChange={e => setOwner(e.target.value === 'true')}
            />
            {showOwnerText && (
                <FormHelperText>
                    Great! Just to give you a heads up that when you submit this
                    CG-719s you will also need to include one of the following:
                    Either your Title for the vessel, the State Registration if
                    State registered, the Certificate of Documentation if
                    registered with the U.S. Coast Guard or the Bill of Sale as
                    proof of ownership to Documents.
                </FormHelperText>
            )}

            {props.children}
        </Section>
    );
};

export default Owner;
